import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { GfTranslateService } from '../../services/core.translate.service';

/**
 * Translate directive — mirrors the translate pipe for attribute-style usage.
 *
 * Usage:
 *   <span translate>Key text</span>
 *   <span [translate]="'Key text'"></span>
 *
 * The element's textContent is used as the lookup key when no binding is provided.
 * Applies translation once on init; the page reloads on language change via
 * stateService.reload(), which recreates components and re-runs this directive.
 */
@Directive({ selector: '[translate]' })
export class TranslateDirective implements OnInit {

    @Input('translate') translateKey: string = '';

    constructor(
        private el: ElementRef,
        private gfTranslateService: GfTranslateService
    ) {}

    ngOnInit() {
        const key = (this.translateKey || '').trim()
            || (this.el.nativeElement.textContent || '').trim();

        if (!key) {
            return;
        }

        const translated = this.gfTranslateService.translate(key);

        // Only update when a real translation was found (instant() returns the key itself
        // as fallback when nothing is loaded yet or the key is missing).
        if (translated && translated !== key) {
            this.el.nativeElement.textContent = translated;
        }
    }
}
